import React, { forwardRef, useImperativeHandle } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
type Props = {};
type Ref = {
  navigate: NavigateFunction;
};
export const globalNavigateControllerRef = React.createRef<Ref>();
const NavigateGlobalController = forwardRef<Ref, Props>(({ }, ref) => {
  const navigate = useNavigate();
  useImperativeHandle(ref, () => ({
    navigate,
  }));

  return null;
});
NavigateGlobalController.displayName = 'NavigateGlobalController';
export default NavigateGlobalController;
